import Immutable from 'immutable';
import * as types from '../../actions/candidate/candidate-link-search-associates-account/types';
import reducerCreator from '../../tools/reducer-creator';

const initialState = Immutable.fromJS({
  errorMessage: null,
  searchAssociatesAccountHasBeenLinked: false,
  isLoading: false
});

export default reducerCreator(initialState, {
  [types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_LOADING]: (
    state,
    { isLoading }
  ) => state.set('isLoading', isLoading),

  [types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_SEARCH_ASSOCIATES_ACCOUNT_HAS_BEEN_LINKED]: (
    state,
    { searchAssociatesAccountHasBeenLinked }
  ) =>
    state.set(
      'searchAssociatesAccountHasBeenLinked',
      searchAssociatesAccountHasBeenLinked
    ),

  [types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_SET_ERROR_MESSAGE]: (
    state,
    { errorMessage }
  ) => state.set('errorMessage', errorMessage),

  [types.CANDIDATE_LINK_SEARCH_ASSOCIATES_ACCOUNT_RESET_STATE]: () =>
    initialState
});



// WEBPACK FOOTER //
// ./src/reducers/candidate/candidate-link-search-associates-account.js